import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useLanguageNavigation } from '../hooks/useLanguageNavigation';
import LanguageSwitcher from './LanguageSwitcher';
import EnhancedLoginForm from './EnhancedLoginForm';

function WelcomeHero() {
  const { currentUser } = useAuth();
  const { navigateWithLang } = useLanguageNavigation();

  // Navigate to portfolio when user becomes authenticated
  useEffect(() => {
    if (currentUser) {
      console.log('🔐 User authenticated, navigating to portfolio');
      navigateWithLang('portfolio');
    }
  }, [currentUser, navigateWithLang]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
      <EnhancedLoginForm />
      
      {/* Language Switcher */}
      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', mt: 3 }}>
        <LanguageSwitcher />
      </Box>
    </Box>
  );
}

export default WelcomeHero;
